// Centralized regex helpers and sanitizers used by the Tranzila popup.

export const ENGLISH_LETTERS_REGEX = /[A-Za-z]/
export const APOSTROPHE_REGEX = /'+/g
export const NON_HEBREW_TEXT_REGEX = /[^\u0590-\u05FF\s]/g
export const HEBREW_AND_WHITESPACE_REGEX = /[\u0590-\u05FF\s]/g
export const NON_ALPHABETIC_TEXT_REGEX = /[^A-Za-z\u0590-\u05FF\s]/g
export const NON_ALPHANUMERIC_ADDRESS_REGEX = /[^A-Za-z0-9\u0590-\u05FF\s/]/g
export const NON_NUMERIC_REGEX = /[^0-9]/g

export function hasEnglishLetters(value: string): boolean {
    return ENGLISH_LETTERS_REGEX.test(value)
}

export function sanitizeFullName(value: string): string {
    return (value || '').replace(NON_HEBREW_TEXT_REGEX, '')
}

export function sanitizeEmail(value: string): string {
    return (value || '').replace(HEBREW_AND_WHITESPACE_REGEX, '')
}

export function sanitizeAddress(value: string): string {
    return (value || '').replace(NON_ALPHANUMERIC_ADDRESS_REGEX, '')
}

export function sanitizeNoNumbers(value: string): string {
    return (value || '').replace(NON_ALPHABETIC_TEXT_REGEX, '')
}

export function sanitizePhone(value: string): string {
    return (value || '').replace(NON_NUMERIC_REGEX, '')
}

export function stripApostrophes(value?: string): string {
    return value ? value.replace(APOSTROPHE_REGEX, '') : ''
}

export function buildHebrewOnlyFullName(firstName: string, lastName: string): string {
    const safeFirstName = firstName && !hasEnglishLetters(firstName) ? firstName : ''
    const safeLastName = lastName && !hasEnglishLetters(lastName) ? lastName : ''
    return `${safeFirstName} ${safeLastName}`.trim()
}
